import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgEyeClosedIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17 9.472a7.07 7.07 0 0 1-1.861-.447L4.03 11.27l-1.086-.618 1.243-2.183a7.172 7.172 0 0 1-1.543-1.271L.855 9.01l-.89-.878 1.91-1.935a7.302 7.302 0 0 1-.832-1.808l1.196-.363c.745 2.452 2.973 4.232 5.658 4.232 2.685 0 4.914-1.78 5.659-4.232l1.196.363a7.302 7.302 0 0 1-.746 1.67l1.916 1.856-.87.897-1.792-1.736a7.174 7.174 0 0 1-1.729 1.44l1.217 2.136-1.086.618-1.26-2.212a7.085 7.085 0 0 1-1.982.431V12H7.17V9.472Z",
    fill: "currentColor"
  }));
}

export { SvgEyeClosedIcon as default };
